import { resolveFileUrl } from '@/components/shared/utils/fileUrl'

function isPdfAttachment(item) {
  const name = String(item?.name || item?.url || '').toLowerCase()
  return name.endsWith('.pdf')
}

/** 标准化 CMS 内容 PDF 附件列表 */
export function normalizeContentAttachments(attachments = []) {
  return (attachments || [])
    .filter((item) => item?.url && isPdfAttachment(item))
    .map((item) => ({
      id: item.id,
      contentId: item.contentId,
      url: resolveFileUrl(item.url),
      name: item.name || '附件.pdf',
      fileSize: Number(item.fileSize) || 0,
      sortOrder: item.sortOrder ?? 0
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder)
}

/** 格式化附件大小 */
export function formatAttachmentSize(bytes = 0) {
  const size = Number(bytes)
  if (!size || size <= 0) return ''
  if (size < 1024) return `${size} B`
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`
  return `${(size / (1024 * 1024)).toFixed(1)} MB`
}
